import { AppMode } from '@customTypes/Generic'
import { useConfig } from '@context/ConfigurationContext'

export const useCalendarVariant = () => {
  const { mode } = useConfig()
  const isGapFiller = mode === AppMode.GAP_FILLER
  return isGapFiller ? 'compact' : 'default'
}
